export function getBlogPublishedLabel(item = {}) {
  return item.Date ? `Opublikowane ${item.Date}` : 'Data publikacji nieznana';
}

export function getBlogSummary(item = {}, limit = 180) {
  const body = item.Body || '';

  if (!body) {
    return 'Wpis archiwalny bez krótkiego opisu.';
  }

  return body.length > limit ? `${body.slice(0, limit)} ...` : body;
}

export function getBlogHeroImageUrl(item = {}, strapiURL = '') {
  const photo = item?.Photos?.[0];
  const imagePath = photo?.formats?.large?.url || photo?.formats?.medium?.url || photo?.formats?.small?.url || photo?.url || '';

  return imagePath ? `${strapiURL}${imagePath}` : '';
}

export function getBlogGalleryItems(item = {}, strapiURL = '') {
  return (item?.Photos || [])
    .map((photo) => {
      const originalPath = photo?.formats?.large?.url || photo?.formats?.medium?.url || photo?.formats?.small?.url || photo?.url || '';
      const thumbnailPath = photo?.formats?.thumbnail?.url || originalPath;

      if (!originalPath) {
        return null;
      }

      return {
        original: `${strapiURL}${originalPath}`,
        thumbnail: thumbnailPath ? `${strapiURL}${thumbnailPath}` : '',
        originalAlt: photo?.alternativeText || item.Title || 'Zdjęcie wpisu',
        thumbnailAlt: photo?.alternativeText || item.Title || 'Miniatura wpisu',
      };
    })
    .filter(Boolean);
}
